import React, { useEffect, useState } from "react"
import styled, { css } from "styled-components"

import { getNumberOfPages, getPagesOfPlayersFromSameDivision, getPagesOfDisplayedDivisions } from "../../utils"

import { StyledDetailedBoardHeaders as PreStyledDetailedBoardHeaders } from "../PublicDetailedBoardPage"

const DESKTOP_SCALE_BY = 0.9
const PHONE_SCALE_BY = 0.7
import { ZERO_WIDTH_SPACE } from "../../unicodeChars"
import FlipMove from "react-flip-move"

const SCENES_WITH_TOTAL_LEADERBOARD = ['4_view_detailed', '1_view', '2_view', '4_view_simple',  '5_view', 'summary']
const SCENES_WITH_CHAPTER_LEADERBOARD = ['4_view_detailed', '1_view', '2_view', '4_view_simple', '5_view']

const TEMP_SCENES_WITH_DIVISIONS_RENDERED = ['4_view_detailed', 'summary']

import { useStore } from '../../zustandStore'
import { shallow } from 'zustand/shallow'

const SortAndPageDashboard = ({
  pushLeaderboardToBroadcast,
}) => {
  const {
    players,
    divisions,
    event,
    obsState,
    
    stagedObsState,
    setStagedObsState,
    unstageObsState,
  } = useStore(
    state => ({
      players:      state.players,
      divisions:    state.divisions,
      event:        state.event,
      obsState: state.obsState,
      
      stagedObsState:    state.stagedObsState,
      setStagedObsState: state.setStagedObsState,
      unstageObsState:   state.unstageObsState,
    }),
    shallow
  )

  let numberOfPages = null
  let pages, _

  if (obsState.currentPageSize) {
    if (event.hasDivisions && TEMP_SCENES_WITH_DIVISIONS_RENDERED.includes(obsState.currentScene)) {
      switch (obsState.currentScene) {
        case '4_view_detailed':
          [pages, _] = getPagesOfDisplayedDivisions(divisions, obsState.currentPageSize)
          break
        case 'summary':
          [pages, _] = getPagesOfPlayersFromSameDivision(divisions, obsState.currentPageSize)
          break
      }
      
      numberOfPages = pages.length
    } else {
      numberOfPages = getNumberOfPages(players, obsState.currentPageSize)
    }
  }

  const [displayedNumberOfPages, setDisplayedNumberOfPages] = useState(numberOfPages)
  useEffect(() => {
    if (obsState.currentSourceType == 'leaderboard' && numberOfPages) {
      setDisplayedNumberOfPages(numberOfPages)
    }
  }, [numberOfPages])
  
  useEffect(() => {
    if (!displayedNumberOfPages) {
      setDisplayedNumberOfPages(getNumberOfPages(players, obsState.currentScenePageSizes.chapter))
    }
  }, [])

  let pageNumbers = []

  if (displayedNumberOfPages) {
    for (let i = 1; i <= displayedNumberOfPages; i++) {
      pageNumbers.push(i)
    }
  }

  const pushPageChangeToBroadcast = (page) => {
    pushLeaderboardToBroadcast({chapterName: obsState.currentChapterName, page: page})
  }

  const onClickColumnHeader = chapterName => e => {
    e.preventDefault()
    if (chapterName == obsState.currentChapterName && obsState.currentSourceType === 'leaderboard') {

      unstageObsState()
    } else {
      setStagedObsState({

        currentSourceType: 'leaderboard',
        currentChapterName: chapterName,
        currentPage: 1
      })
    }
  }

  const onDoubleClickColumnHeader = chapterName => e => {
    e.preventDefault()
    pushLeaderboardToBroadcast({ chapterName: chapterName, page: 1 })
  }

  const onClickPageNumber = pageNum => e => {
    e.preventDefault()
    if (pageNum != obsState.currentPage) {
      setStagedObsState({
        currentSourceType: 'leaderboard',
        currentChapterName: obsState.currentChapterName,
        currentPage: pageNum
      })
    } else {
      unstageObsState()
    }
  }

  const onDoubleClickPageNumber = pageNum => e => {
    e.preventDefault()
    if (pageNum != obsState.currentPage) {
      pushLeaderboardToBroadcast({
        chapterName: obsState.currentChapterName,
        page: pageNum
      })
    }
  }

  const setStagedPageNumber = pageNum => {
    setStagedObsState({
      currentSourceType: 'leaderboard',
      currentChapterName: obsState.currentChapterName,
      currentPage: pageNum
    })
  }

  const pageControlsEnabled = obsState.currentPageSize != null

  const outlineStagedChapter =
    stagedObsState.currentSourceType === 'leaderboard'
    && (stagedObsState.currentPage === 1 || stagedObsState.currentPage == null)
    && (stagedObsState.currentChapterName !== obsState.currentChapterName || obsState.currentSourceType === 'player')

  const totalHoverable = (
    SCENES_WITH_TOTAL_LEADERBOARD.includes(obsState.currentScene)
    && (
      obsState.currentSourceType !== 'leaderboard'
      || obsState.currentChapterName != null
    )
  )

  const totalSelected = SCENES_WITH_TOTAL_LEADERBOARD.includes(obsState.currentScene) && obsState.currentSourceType === 'leaderboard' && obsState.currentChapterName === null
  return (
    <FullWidthFlexColumn>
      <StyledDetailedBoardHeaders
        key='header'
        className='header-row row'
        onDoubleClickColumnHeader={onDoubleClickColumnHeader}
        onClickColumnHeader={onClickColumnHeader}
        chapterNames={event.chapterNames}
        playerColumnDisabled
        sortingByChapterName={obsState.currentChapterName}
        scaleBy={DESKTOP_SCALE_BY}
        scaleByOnPhone={PHONE_SCALE_BY}
        outlineStagedChapter={outlineStagedChapter}
        stagedChapterName={stagedObsState.currentChapterName}
        includeTotal
        disableAll={event.isBingo || !SCENES_WITH_CHAPTER_LEADERBOARD.includes(obsState.currentScene)}
        disableTotal={event.isBingo || !SCENES_WITH_TOTAL_LEADERBOARD.includes(obsState.currentScene)}
        totalHoverable={totalHoverable}
        totalSelected={totalSelected}
        includeTooltips
      >
        {SCENES_WITH_TOTAL_LEADERBOARD.includes(obsState.currentScene)
          ? 'Show Leaderboard'
          : 'Show Chapter Leaderboard'
        }:
      </StyledDetailedBoardHeaders>

      <FlipMove maintainContainerHeight delay={2350} duration={400} enterAnimation='fade' leaveAnimation='fade'>
        {!pageControlsEnabled ? (
          <DisabledDiv key='disabled-div' />
        ) : null}
        <PageButtons key='page-buttons' sortingIsDefault={obsState.currentChapterName == null}>
          <div
            disabled={obsState.currentPage === 1 || !pageControlsEnabled}
            className={`page-button ${obsState.currentPage === 1 || !pageControlsEnabled ? 'disabled' : ''}`}
            onDoubleClick={() => pushPageChangeToBroadcast(obsState.currentPage - 1)}
            onClick={() => setStagedPageNumber(obsState.currentPage - 1)}
          >
            <div>Previous Page</div>
            <div className='arrow'>&larr;</div>
          </div>
          <div className={`live-values`}>
            <div className={`players-rank-range`}>
              {ZERO_WIDTH_SPACE}
            </div>
            <div className='numbers-wrapper longer-transition'>
              {pageNumbers.map(pageNum => {
                let className = 'page-number longer-transition'
                if (pageControlsEnabled) {
                  if (pageNum == obsState.currentPage) className += ' selected-page'
                  if (pageNum == stagedObsState.currentPage && stagedObsState.currentChapterName === obsState.currentChapterName) className += ' staged-page'
                }
                return (
                  <span
                    key={pageNum}
                    onClick={onClickPageNumber(pageNum)}
                    onDoubleClick={onDoubleClickPageNumber(pageNum)}
                    className={className}
                  >
                    {pageNum}
                  </span>
                )
              })}
            </div>
            <div className='players-rank-range spacer'>{ZERO_WIDTH_SPACE}</div>
          </div>
          <div
            className={`page-button ${obsState.currentPage === numberOfPages || !pageControlsEnabled ? 'disabled' : ''}`}
            onDoubleClick={() => pushPageChangeToBroadcast(obsState.currentPage + 1)}
            onClick={() => setStagedPageNumber(obsState.currentPage + 1)}
          >
            <div>Next Page</div>
            <div className='arrow'>&rarr;</div>
          </div>
        </PageButtons>
      </FlipMove>
    </FullWidthFlexColumn>
  )
}

export default SortAndPageDashboard

const DisabledDiv = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #2228;
`

const PageButtons = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin: 5px 0;
  font-size: 1.7em;

  .arrow {
    line-height: 0.65em;
    font-size: 1.7em;
  }

  .page-button {
    padding: 0 5px 3px 5px;
    min-width: 180px;
    height: 80px;
    border-radius: 3.5px;
    border: 2px solid #aaa;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &.disabled {
      cursor: default;
      background-color: var(--greyed-out-button-bg);
      color: var(--greyed-out-button-text);
      border-color: var(--greyed-out-button-text);
      pointer-events: none;
    }
    &:not(.disabled) {
      &:hover { background-color: var(--green-hover); }
      &:active { background-color: var(--green-active); }
    }
  }

  .current-scene {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 0.8em;
    max-width: 134px;
  }

  .live-values {
    display: grid;
    border: 2px solid #0000;
    border-radius: 3.5px;
    padding: 5px;
    min-width: 180px;
    max-width: 180px;
    &.hidden {
      visibility: hidden;
    }
  }

  .numbers-wrapper {
    grid-column: 1;
    grid-row: 2;
    border-top: 2px solid #aaa;
    border-bottom: 2px solid #aaa;
    display: flex;
    min-width: 100%;
    justify-content: space-between;
    align-items: center;
    border-color: #aaa;
  }

  .players-rank-range {
    grid-column: 1;
    grid-row: 1;
    font-size: 0.8em;
    line-height: 1.5em;
    &.spacer {
      visibility: hidden;
      grid-row: 3;
    }
    .chapter-rank {
      color: var(--chapter-rank-color);
    }
    .total-rank {
      color: var(--rank-color);
    }
  }

  .darkening-div {
    grid-row: 1;
    grid-column: 1;
    width: 100%;
    height: 100%;
    background-color: #333;
    opacity: 0.35;
    cursor: not-allowed;
  }

  .page-number {
    min-width: 40px;
    flex-grow: 1;
    text-align: center;
    padding: 3px;
  }
  .selected-page {
    background-color: var(--green-selected);
  }
  .staged-page {
    border: 3px dashed var(--green-text);
    padding: 0px;
  }
  .page-number:not(.selected-page) {
    transition-duration: var(--normal-transition-duration);
    cursor: pointer;
    &:hover { background-color: var(--green-hover); }
    &:active { background-color: var(--green-active); }
  }
`

const FullWidthFlexColumn = styled(FlipMove)`
  width: 98%;
  max-width: var(--detailed-board-width);
  display: flex;
  flex-direction: column;
  background: linear-gradient(243deg, #33152d, #141732);
  --page-hover-color: var(--green-hover);
  --page-active-color: var(--green-active);
  --page-selected-color: var(--green-selected);
`

const StyledDetailedBoardHeaders = styled(PreStyledDetailedBoardHeaders)`
  --header-hover-color: var(--green-hover);
  --header-selected-color: var(--green-selected);
  --header-active-color: var(--green-active);
  user-select: none;

  @media only screen and (min-width: ${() => `${window.phoneCutoffSizePx}px`}) {
    --player-column-width: ${() => DESKTOP_SCALE_BY * 230}px;
    --time-column-width: ${() => DESKTOP_SCALE_BY * 102}px;
    font-size: 34.67px;
  }
  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) {
    --player-column-width: 20vw;
    --time-column-width: 9vw;
    font-size: 2.5vw;
    border-top-width: 1.5px;
    border-bottom-width: 1.5px;
  }

  .column-player-children {
    opacity: 1!important;
  }

  .column-staged {
    padding: 0px;
    border: 3px dashed var(--green-text);
  }

  ${props => props.disableAll && css`
    pointer-events: none;
    * {
      pointer-events: none;
    }
  `}
`



